import { config } from '@/config';
import { authenticatedApiCall } from './keycloak-auth';

export interface PublicFeatureFlag {
  code: string;
  enabled: boolean;
}

export interface InternalFeatureFlag {
  code: string;
  name: string;
  description: string | null;
  enabled: boolean;
}

export async function getPublicFeatureFlags(): Promise<PublicFeatureFlag[]> {
  const response = await fetch(`${config.api.baseURL}/public/feature-flags`, {
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  });
  if (!response.ok) throw new Error('Failed to fetch feature flags');
  const body = await response.json();
  return body?.data ?? body;
}

export async function getInternalFeatureFlags(): Promise<InternalFeatureFlag[]> {
  return authenticatedApiCall<InternalFeatureFlag[]>('/internal/feature-flags', {
    method: 'GET',
  });
}

export async function setFeatureFlag(
  code: string,
  enabled: boolean
): Promise<{ code: string; enabled: boolean }> {
  return authenticatedApiCall<{ code: string; enabled: boolean }>(
    `/internal/feature-flags/${code}`,
    {
      method: 'PUT',
      body: JSON.stringify({ enabled }),
    }
  );
}
